export const isMobileNativeApp=() => !!(window.webkit || window.AndroidInterface);
